<script>
  import { selectedDistrict } from "@stores/userData.js";

  export let member;
  export let isStandalone = false;

  $: active = member["District"] === $selectedDistrict;

  let element;

  const MARGIN_ABOVE_CARD = 5;

  $: active, setScroll(element);

  import viewport from "@stores/viewport.js";

  $: setScroll = function (element) {
    if (
      isStandalone ||
      !active ||
      !element ||
      typeof element == "number" ||
      !document
    )
      return;

    let left, top;

    if ($viewport.width < 768) {
      left = element.offsetLeft - MARGIN_ABOVE_CARD;
      top = 0;
    } else {
      left = 0;
      top = element.offsetTop - MARGIN_ABOVE_CARD;
    }

    document
      .getElementById("city-council-list")
      .scrollTo({ top: top, left: left, behavior: "smooth" });
  };

  import { onMount } from "svelte";
  onMount(() => {
    if (active) setScroll(element.offsetTop - MARGIN_ABOVE_CARD);
  });
</script>

<button
  bind:this={element}
  class="box"
  id="council-member-{member['District']}"
  class:isStandalone
  class:active={member["District"] === $selectedDistrict}
  class:inactive={$selectedDistrict && member["District"] !== $selectedDistrict}
  on:click={() => {
    selectedDistrict.set(member["District"]);
  }}
>
  <div class="cards-info">
    <div class="top">
      <p class="position">
        {member["Position"]}
      </p>
      <h1 class="name">
        {member["Name"]}
      </h1>
    </div>

    <div class="middle">
      <p class="email">
        {member["Email"]}
      </p>
      <p class="phone">
        {member["Phone"]}
      </p>
    </div>

    <div class="bottom">
      {#if member["Twitter"]}
        <a
          class="twitter link"
          href="https://twitter.com/{member['Twitter']}"
          target="_blank"
          rel="noopener noreferrer"
        >
          {member["Twitter"]}
        </a>
      {/if}
      {#if member["Facebook"]}
        <a
          class="facebook link"
          href={member["Facebook"]}
          target="_blank"
          rel="noopener noreferrer"
        >
          Facebook
        </a>
      {/if}
    </div>
  </div>
  <div class="cards-profile">
    <img
      src="./images/council-members/{member['imageFileName']}"
      alt={member["Name"]}
    />
    <a
      class="website"
      href={member["Department Website"]}
      target="_blank"
      rel="noopener noreferrer"
    >
      More info
    </a>
  </div>
</button>

<style>
  .name {
    font-size: 1.5rem;
    font-family: var(--font-serif);
    margin-bottom: 0.25rem;
    line-height: 1.2;
  }

  .position {
    text-transform: uppercase;
    font-weight: 300;
    color: rgba(var(--text-color-rgb), 0.7);
    font-size: 0.9rem;
    margin-bottom: 0.2rem;
  }

  .cards-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .cards-profile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
  }

  .website {
    margin-top: 0.5rem;
    text-transform: uppercase;
    font-size: 0.8rem;
    color: var(--text-color);
  }

  .website:hover {
    text-decoration: none;
  }

  .link {
    text-decoration: none;
    font-size: 0.8rem;
  }

  /* Add a bullet after Twitter */
  .twitter::after {
    content: "\2022";
    margin-left: 0.2rem;
  }

  .box.active {
    outline: 1px solid var(--accent-color);
  }

  .box.inactive {
    opacity: 0.65;
  }

  .box.active img {
    filter: grayscale(0);
  }

  .email {
    font-size: 0.8rem;
    color: rgba(var(--text-color-rgb), 0.7);
    margin-bottom: 0.2rem;
  }
  .phone {
    font-size: 0.8rem;
    color: rgba(var(--text-color-rgb), 0.7);
  }

  .box {
    width: 100%;
    /* min-width: 325px; */
    max-width: 400px;
    box-shadow: 1px 1px 7px rgba(var(--text-color-rgb), 0.5);
    position: relative;
    z-index: 2;
    margin: 1rem;
    user-select: none;
    -webkit-user-select: none; /* Chrome/Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+ */
    background: var(--primary-color-base);
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    text-align: left;
    padding: 1rem;
    cursor: pointer;
    border-radius: 0.2rem;
    transition: opacity 300ms ease, transform 300ms ease;
  }

  .box:hover {
    transform: translateY(-2.5px);
    opacity: 1;
  }

  .box img {
    max-width: 120px;
    filter: grayscale(100%);
    transition: filter 200ms ease-in-out;
    border-radius: 50%;
  }
  .box:hover img {
    filter: grayscale(0%);
  }

  @media screen and (max-width: 768px) {
    .box {
      margin: 0 0.25rem;
    }
  }

  .isStandalone {
    max-width: none;
    width: 100%;
    margin: 0;
  }

  @media screen and (max-width: 400px) {
    .box img {
      max-width: 100px;
    }
  }
</style>
